<template>
	<div id="accordionPanelsStayOpenExample" class="accordion">
		<div class="accordion-item">
			<h2 id="panelsStayOpen-headingOne" class="accordion-header">
				<button
					class="accordion-button" type="button" data-bs-toggle="collapse"
					data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
					aria-controls="panelsStayOpen-collapseOne">
					Assessment details
				</button>
			</h2>
			<div
				id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
				aria-labelledby="panelsStayOpen-headingOne">
				<div class="accordion-body">
					<p>
						<span class="fw-bold">{{ trans('global.labels.surveyor') }}: </span>{{ survey.surveyor_name }}
					</p>

					<p v-if="JSON.parse(survey?.survey_data)?.survey_type=='wca'">
						<span class="fw-bold">{{ trans('global.labels.woodland_type') }}: </span>
						{{ trans('global.phrases.'+getWoodlandType(survey)+'_woodland') }}
					</p>
					<div v-else-if="JSON.parse(survey?.survey_data)?.survey_type=='bng'">
						<p>
							<span class="fw-bold me-2">{{ trans('global.labels.habitats_present') }}:</span>
							<span class="badge bg-info me-2">
								{{ trans('global.report.habitat_type_'+habitatType) }}
							</span>
						</p>
						<p>
							<span class="fw-bold me-2">{{ trans('global.labels.parcel') }}:</span>
							<span class="badge bg-info me-2">{{ parcelIdentifier }}</span>
						</p>
					</div>

					<span v-else>{{ trans('global.phrases.could_not_detect') }} Reason: probably not enough plots
						complete</span>
					<p v-if="JSON.parse(survey?.survey_data)?.survey_type=='wca'">
						<span>
							<span class="fw-bold me-2">{{ trans('global.labels.woodland_type_by_area') }}:</span>
							<br>
							Total: {{ JSON.parse(props.survey.survey_data).question14a }} ha
							<br>
							{{ trans('global.phrases.c_woodland') }}: {{ JSON.parse(props.survey.survey_data).question14c }} ha
							<br>
							{{ trans('global.phrases.b_woodland') }}: {{ JSON.parse(props.survey.survey_data).question14b }} ha
						</span>
					</p>

					<p class="card-text">
						<span class="fw-bold">{{ trans('global.labels.plots') }}:</span> {{ survey.plot_surveys?.length
						}}
					</p>
				</div>
			</div>
		</div>

		<div class="accordion-item">
			<h2 id="panelsStayOpen-headingTwo" class="accordion-header">
				<button
					class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
					data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
					aria-controls="panelsStayOpen-collapseTwo">
					Download data for this survey
				</button>
			</h2>
			<div
				id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
				aria-labelledby="panelsStayOpen-headingTwo">
				<div class="accordion-body">
					<p type="button" class="btn btn-light" @click.prevent="generateAnswersPDF_woodland()">
						<i class="bi bi-box-arrow-down me-2" />Whole woodland
					</p>
					<p
						v-for="plot,i in survey.plot_surveys"
						:key="i">
						<span
							type="button" class="btn btn-light"
							@click.prevent="generateAnswersPDF_plots(plot, i + 1, 'Plot ' + String(i + 1) + ((JSON.parse(plot.survey_data)?.location_descriptor!= ' ' && JSON.parse(plot.survey_data)?.location_descriptor!= '' && JSON.parse(plot.survey_data)?.location_descriptor!= undefined) ? ' - ' + JSON.parse(plot.survey_data).location_descriptor.substring(0,10) : ''))">
							<i class="bi bi-box-arrow-down me-2" />Plot {{ i + 1 }}{{
								(JSON.parse(plot.survey_data)?.location_descriptor!= " " &&
									JSON.parse(plot.survey_data)?.location_descriptor!= "" &&
									JSON.parse(plot.survey_data)?.location_descriptor!= undefined) ? ' - ' +
									JSON.parse(plot.survey_data)?.location_descriptor.substring(0,10) +
									(JSON.parse(plot.survey_data)?.location_descriptor.length > 10 ? '...' : '') : '' }}
						</span>
					</p>
					<p v-show="survey.type=='wca'" type="button" class="btn btn-light" @click.prevent="exportForestLab()">
						<i class="bi bi-box-arrow-down me-2" />Export raw data
					</p>
				</div>
			</div>
		</div>
		<div class="accordion-item">
			<h2 id="panelsStayOpen-headingThree" class="accordion-header">
				<button
					class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
					data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
					aria-controls="panelsStayOpen-collapseThree">
					{{ survey.complete==0 ? 'Provisional survey results' : 'Survey results' }}
				</button>
			</h2>
			<div
				id="panelsStayOpen-collapseThree" class="accordion-collapse collapse"
				aria-labelledby="panelsStayOpen-headingThree">
				<div class="accordion-body">
					<h4 v-text="survey.complete==0 ? 'Provisional survey results' : 'Survey results'" />
					<p>
						Further information on scoring can be found in
						<a :href="'/' + guideString + '.pdf'" :download="guideString + '.pdf'">{{ guideString }}</a>.
					</p>
					<div v-if="details && (provisional_survey_score != null)">
						<div class="card-text my-3">
							<div v-if="JSON.parse(survey?.survey_data)?.survey_type=='bng'">
								<span class="fw-bold">{{ trans('global.labels.score') }}: </span>
								{{ provisional_survey_score.m }}
								<span v-if="!(typeof provisional_survey_score === 'string')">
									(/{{ JSON.parse(survey?.survey_data)?.survey_type == "bng" ? 39 : 45 }}) -
								</span>
								<span v-if="typeof provisional_survey_score=== 'string'" />
								<span v-else-if="provisional_survey_score.m<26" class="badge bg-danger">
									{{ trans('global.labels.poor').toUpperCase() }}
								</span>
								<span v-else-if="provisional_survey_score.m<36" class="badge bg-warning">
									{{ trans('global.labels.moderate').toUpperCase() }}
								</span>
								<span v-else class="badge bg-success">
									{{ trans('global.labels.good').toUpperCase() }}
								</span>
							</div>
							<div v-else-if="JSON.parse(survey?.survey_data)?.survey_type=='wca'">
								<div v-if="has_broadleaved">
									<span
										class="fw-bold"
										v-text="has_conifer? 'Broadleaved, mixed and Yew woodland: ' : 'Score (broadleaved, mixed and Yew woodland only): '" />
									{{ provisional_survey_score.b }}
									<span v-if="typeof provisional_survey_score=== 'string'" />
									<span v-else-if="provisional_survey_score.b<26" class="badge bg-danger">
										{{ trans('global.labels.poor').toUpperCase() }}
									</span>
									<span v-else-if="provisional_survey_score.b<36" class="badge bg-warning">
										{{ trans('global.labels.moderate').toUpperCase() }}
									</span>
									<span v-else class="badge bg-success">
										{{ trans('global.labels.good').toUpperCase() }}
									</span>
								</div>
								<br v-if="has_conifer && has_broadleaved">
								<div v-if="has_conifer">
									<span
										class="fw-bold"
										v-text="has_broadleaved? 'Coniferous woodland: ' : 'Score (coniferous woodland only): '" />
									{{ provisional_survey_score.c }}
									<span v-if="typeof provisional_survey_score=== 'string'" />
									<span v-else-if="provisional_survey_score.c<26" class="badge bg-danger">
										{{ trans('global.labels.poor').toUpperCase() }}</span>
									<span v-else-if="provisional_survey_score.c<36" class="badge bg-warning">
										{{ trans('global.labels.moderate').toUpperCase() }}</span>
									<span v-else class="badge bg-success">
										{{ trans('global.labels.good').toUpperCase() }}
									</span>
								</div>

								<span v-if="has_conifer && has_broadleaved"><br>In the table below, 'c' denotes the
									score for conifer woodland, 'b' denotes that of broadleaved woodland.</span>
							</div>
							<div v-else>
								Please edit survey and select survey type in order to score your assessment.
							</div>
						</div>

						<div id="plotAccordion" class="accordion">
							<div
								v-for="loopIndex in provisional_survey_score.numQs" :key="loopIndex"
								class="accordion-item">
								<h2 :id="'heading_'+loopIndex" class="accordion-header">
									<button
										class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
										aria-expanded="false" :data-bs-target="'#collapse_'+loopIndex"
										:aria-controls="'collapse_'+loopIndex">
										<div v-if="JSON.parse(survey?.survey_data)?.survey_type=='wca'">
											{{ provisional_survey_score.advice_b[loopIndex - 1][0] }}
										</div>
										<div v-else-if="JSON.parse(survey?.survey_data)?.survey_type=='bng'">
											{{ provisional_survey_score.advice_m[loopIndex - 1][0] }}
										</div>

										<div v-if="JSON.parse(survey?.survey_data)?.survey_type=='wca'">
											<span
												v-if="has_broadleaved && provisional_survey_score.advice_b[loopIndex - 1][1].b > 0"
												class="badge rounded-pill mx-2"
												:class="'badge-'+provisional_survey_score.advice_b[loopIndex - 1][1].b"
												v-text="(has_conifer ? 'b-' : '') + provisional_survey_score.advice_b[loopIndex - 1][1].b" />
											<span
												v-if="has_conifer && provisional_survey_score.advice_b[loopIndex - 1][1].c > 0"
												class="badge rounded-pill mx-2"
												:class="'badge-'+provisional_survey_score.advice_b[loopIndex - 1][1].c"
												v-text="(has_broadleaved ? 'c-' : '') + provisional_survey_score.advice_b[loopIndex - 1][1].c" />
										</div>
										<div
											v-if="JSON.parse(survey?.survey_data)?.survey_type=='bng' && provisional_survey_score.advice_m[loopIndex - 1][1].m > 0">
											<span
												class="badge rounded-pill mx-2"
												:class="'badge-'+provisional_survey_score.advice_m[loopIndex - 1][1].m">
												{{ provisional_survey_score.advice_m[loopIndex - 1][1].m }}
											</span>
										</div>
									</button>
								</h2>
								<div
									:id="'collapse_'+loopIndex" class="accordion-collapse collapse "
									:aria-labelledby="'heading_'+loopIndex" data-bs-parent="#plotAccordion">
									<div class="accordion-body">
										<div v-if="JSON.parse(survey?.survey_data)?.survey_type=='wca'">
											<div
												v-if="has_broadleaved && provisional_survey_score.advice_b[loopIndex - 1][1].b > 0">
												<span v-if="has_conifer"><strong>Broadleaved:&nbsp;</strong></span>
												{{ scoreString[provisional_survey_score.advice_b[loopIndex - 1][1].b] }}
												<br>
												{{ provisional_survey_score.advice_b[loopIndex - 1][2] }}
											</div>
											<div
												v-if="has_conifer && provisional_survey_score.advice_c[loopIndex - 1][1].c > 0"
												class="mt-2">
												<span v-if="has_broadleaved"><strong>Conifer:&nbsp;</strong></span>
												{{ scoreString[provisional_survey_score.advice_c[loopIndex - 1][1].c] }}
												<br>
												{{ provisional_survey_score.advice_c[loopIndex - 1][2] }}
											</div>
										</div>
										<div v-else-if="JSON.parse(survey?.survey_data)?.survey_type=='bng'">
											{{ scoreString[provisional_survey_score.advice_m[loopIndex - 1][1].m] }}
											<br>
											<span v-if="provisional_survey_score.advice_m[loopIndex - 1][1].m > 0">{{
												provisional_survey_score.advice_m[loopIndex - 1][2] }}</span>
											<span v-else>Not enough data provided, or there is an error in your survey
												responses.</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<br>

	<div v-if="survey.complete==0">
		<!-- <div v-if="survey.complete==0 && provisional_survey_score!=null"> -->
		<router-link
			class="me-2"
			:to="'/editsurvey/' + survey.id + '/' + siteId + '/' + estateId + '/' + clientId">
			<!-- class="btn btn-theme"> -->
			<UiButton
				v-if="(typeof provisional_survey_score) === 'string' || provisional_survey_score==null || provisional_survey_score.m==0"
				theme="theme"
				:label="'Update ' + trans('global.labels.survey')"/>
			<UiButton
				v-else
				theme="theme"
				:label="trans('global.actions.update') + ' ' + trans('global.labels.survey')"/>
		</router-link>
		<!-- if theres an error, dont allow the submit button, and display an info button for pop up -->
		<span
			v-if="errors.length || !checkAllValidated"
			class="me-2"
			data-bs-toggle="modal"
			:data-bs-target="'#exampleModal'+index"
		>
			<UiButton
				theme="error"
				icon="bi-info-circle"
				label=""
				:class="runningCalculations ? 'disabled' : ''"
			/>
		</span>
		<!-- otherwise.. -->
		<span v-else class="me-2">
			<span
				class="me-2"
				data-bs-toggle="modal"
				:data-bs-target="'#exampleModal2'+index">
				<UiButton
					theme="info"
					:label="trans('global.actions.submit')"
					:class="runningCalculations ? 'disabled' : ''"
				/>
			</span>
			<!-- if there's a warning, on submit, have the submit anyway button on the warning dialog -->
			<span
				v-if="warnings.length"
				data-bs-toggle="modal"
				:data-bs-target="'#exampleModal'+index">
				<!-- and display the icon for a separate popup -->

				<UiButton
					theme="warning"
					icon="bi-question-diamond text-white"
					label=""
					:class="runningCalculations ? 'disabled' : ''"
				/>
			</span>
		</span>

		<!-- Alert Modal -->
		<div
			v-if="errors.length || warnings.length || !checkAllValidated"
			:id="'exampleModal'+index" class="modal fade" tabindex="-1" :aria-labelledby="'exampleModal'+index+'Label'"
			aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 :id="'exampleModal'+index+'Label'" class="modal-title">
							<span v-if="errors.length || !checkAllValidated">{{
								trans('global.phrases.fix_the_error_before_submitting') }}</span>
							<span v-else-if="warnings.length">
								{{ trans('global.labels.warning') }}
							</span>
						</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
					</div>
					<div class="modal-body">
						<div v-if="errors.length || !checkAllValidated">
							Errors:
							<ul>
								<li v-if="!preAssessmentValid">
									One or more of your pre-assessment (desk-based) questions is incomplete. Please
									check and update your assessment.
									<a
										:href="'/editsurvey/' + survey.id + '/' + siteId + '/' + estateId + '/' + clientId + '/preassess'">
										Go to assessment
									</a>
								</li>
								<li v-if="!walkAssessmentValid">
									One or more of your woodland walk questions is incomplete. Please check and update
									your assessment.
									<!-- <a :href="'/editsurvey/' + survey.id + '/' + siteId + '/' + estateId + '/' + clientId + '#home'">Edit</a> -->
									<a
										:href="'/editsurvey/' + survey.id + '/' + siteId + '/' + estateId + '/' + clientId + '/home'">
										Go to assessment
									</a>
								</li>
								<li v-show="!allPlotsValid">
									The following plot{{ invalidPlots.length > 1 ? "s have" : " has" }} invalid answers
									to one or more question:
									<ul>
										<li v-for="(item,ind) in invalidPlots" :key="ind">
											Plot {{ item.index }}{{ item.name }}
											<a :href="item.link">Go to assessment</a>
										</li>
									</ul>
								</li>
								<li v-for="( thiserror, ind ) in errors" :key="ind">
									{{ thiserror }}
								</li>
							</ul>
						</div>
						<div v-if="warnings.length">
							Warnings:
							<ul>
								<li v-for="( thiserror, ind) in warnings" :key="ind">
									{{ thiserror }}
								</li>
							</ul>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
							{{ trans('global.buttons.close') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<!-- Submit (anyway?) Modal -->
		<div v-if="!errors.length" :id="'exampleModal2'+index" class="modal fade" tabindex="-1" :aria-labelledby="'exampleModal2'+index+'Label'" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 :id="'exampleModal2'+index+'Label'" class="modal-title">
							{{ trans('global.phrases.are_you_sure_you_want_to_submit') }}
							<span v-if="warnings.length" class="ms-2">({{
								trans('global.labels.warning') }})</span>
						</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
					</div>
					<div class="modal-body">
						<p>{{ trans('global.phrases.confirming_submit_is_final') }}</p>
						<p v-if="warnings.length">
							{{ trans('global.phrases.we_recommend_the_following') }}:
							<ul v-if="warnings.length">
								<li v-for="(warning,ind) in warnings" :key="ind">
									{{ warning }}
								</li>
							</ul>
						</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
							{{ trans('global.buttons.close') }}
						</button>
						<button v-if="warnings.length" type="button" class="btn btn-theme" data-bs-dismiss="modal" @click.prevent="submitSurvey(survey)">
							{{ trans('global.buttons.submit_anyway') }}
						</button>
						<button v-else type="button" class="btn btn-theme" data-bs-dismiss="modal" @click.prevent="submitSurvey(survey)">
							{{ trans('global.buttons.submit') }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-else>
		<div>
			<button type="button" class="btn btn-theme" @click.prevent="generatePDF">
				<i class="bi-file-pdf me-2" />{{ trans('global.buttons.save_report') }}
			</button>
		</div>
	</div>
	<br>
	<div class="container-fluid">
		<p class="px-2 small">
			<span class="fst-italic text-muted">{{ trans('global.labels.last_modified') }}: {{ formatUpdatedAt() }}</span>
		</p>
		<p class="px-2 small">
			<span class="fst-italic text-muted">Last synced: {{ survey.synced_at ? formatSyncedAt() : "" }}</span>
		</p>
	</div>
</template>

	<script lang="ts" setup>
	import { watch, computed, onMounted, ref } from "vue";
	import { useRoute } from "vue-router";
	import { trans } from "@/helpers/i18n";
	import UiButton from "@/views/components/input/UiButton.vue";

	import { useAuthStore } from "@/stores/auth";
	import { useSurveyStore } from "@/stores/survey";
	import { usePwaStore } from "@/stores/pwa";
	import { useWoodlandSurveyStore } from "@/stores/woodland";
	import SurveyService from "@/services/SurveyService";
	import { v4 as uuidv4 } from "uuid";

	import { scoreSurvey_WCA,
		scoreSurvey_BNG,
		getWoodlandType,
		getWarnings,
		getErrors,
		getXLSString,
		surveyPlotCoordinates, siteSurveyPlotCoordinates,
		surveyCentre,
		surveyMarkerNames } from "@/modules/woodlandSurvey";

	import { Model } from "survey-core";
	import { preAssessmentSurveyJson } from "@/Components/preAssessmentSurveyJson";
	// import { woodlandSurveyJson } from "@/Components/woodlandSurveyJson";
	import { plotSurveyJson } from "@/Components/plotSurveyJson";
	import type { WoodlandSurvey } from "@/types/survey";

	import { PDFDocument, PDFPage, PDFFont, StandardFonts, rgb, layoutMultilineText, TextAlignment, degrees } from "pdf-lib";
	import { saveAs } from "file-saver";

	// import { SurveyPDF } from "survey-pdf";
	// import { DocController, SurveyHelper, FlatQuestion } from "survey-pdf";
	import { woodlandSurveyJson } from "@/Components/woodlandSurveyJson";
	import "survey-core/defaultV2.min.css";

	import type { PlotSurvey } from "@/types/survey";
	import { useAlertStore } from "@/stores";
	import axios from "axios";

	const props = defineProps<{
		gridref: string,
		site: string,
		survey: WoodlandSurvey,
		htr: string|null;
		sbi: string|null;
		wmp: string|null;
		details: boolean;

		siteId: string,
		estateId: string,
		clientId: string
	}>();

	const authStore = useAuthStore();
	const surveyStore = useSurveyStore();
	const pwaStore = usePwaStore();
	const woodlandSurveyStore = useWoodlandSurveyStore();
	const alertStore = useAlertStore();
	const scoreString = [
		trans("global.alerts.danger"),
		capitalise(trans("global.labels.poor")),
		capitalise(trans("global.labels.moderate")),
		capitalise(trans("global.labels.good"))];

	// MAPPING
	// Resolve the survey and its ancestors reactively from the auth store on every
	// access. When another device is detected, checkDevice() -> authStore.getCurrentUser()
	// replaces the whole user object graph, which would leave plain captured references
	// pointing at stale, detached objects and make loadData()'s output inconsistent.
	const client = computed(() => authStore.user?.clients?.find((x: any) => x.id == props.clientId));
	const estate = computed(() => client.value?.estates?.find((x: any) => x.id == props.estateId));
	const site = computed(() => estate.value?.sites?.find((x: any) => x.id == props.siteId));
	// Fall back to the prop so downstream code always has a survey to work with.
	const surveyById = computed(() => site.value?.woodland_surveys?.find((x: any) => x.id == props.survey.id) ?? props.survey);

	const position = ref({ latitude: 0, longitude: 0 });
	let error:any = ref(null);
	const lat = computed(() => {
		return position.value.latitude;
	});
	const lon = computed(() => {
		return position.value.longitude;
	});
	const center = computed(() => {
		return surveyCentre(props.survey, site.value);
	});
	const coordinates = computed(() => {
		// return siteSurveyPlotCoordinates(site);
		return surveyPlotCoordinates(props.survey, "yellow");
	});
	const markerNames = computed(() => {
		return surveyMarkerNames(props.survey, false);
	});
	function getLocation () {
		if ("geolocation" in navigator) {
			navigator.geolocation.getCurrentPosition(
				(pos) => {
					// Handle success
					position.value = {
						latitude: pos.coords.latitude,
						longitude: pos.coords.longitude
					};
				},
				(err) => {
					position.value = { latitude: 0, longitude: 0 };
					if (err.code === err.PERMISSION_DENIED) {
						// alert("Location access denied. Please enable location services in Settings.");
						console.error("Location access denied. Please enable location services in Settings.");
						error.value = "Location access denied. Please enable location services in Settings.";
					} else {
						// console.error("Error occurred while getting location:", err);
						error.value = "Error occurred while getting location: " + err;
					}
				},
				{
					enableHighAccuracy: true,
					timeout: 10000,
					maximumAge: 0
				}
			);
		}
		else {
			console.error("Geolocation is not supported by your browser");
			return;
			// alert("Geolocation is not supported by your browser.");
		}

	}
	// call getLocation every 1 seconds to keep it updated on live map
	const seconds = 1;
	const intervalID = setInterval(async () => {
		getLocation();
	}, seconds * 1000);

	const index = computed(() => {
		return props.survey.id;
	});
	const guideString = computed(() => {
		return JSON.parse(props.survey?.survey_data)?.survey_type == "bng" ? "WCA6" : "WCA5";
	});
	const errors = ref([]);
	const warnings = ref([]);
	const has_conifer = computed(() => {
		return JSON.parse(props.survey.survey_data).question14c && JSON.parse(props.survey.survey_data).question14c > 0;
	});
	const has_broadleaved = computed(() => {
		return JSON.parse(props.survey.survey_data).question14b && JSON.parse(props.survey.survey_data).question14b > 0;
	});
	const woodlandTypeByArea = computed(() => {
		let r = getWoodlandType(props.survey);
		if (r == "b")
			return "Broadleaved, mixed and yew woodland";
		else if (r == "c")
			return "Coniferous woodland";
		else if (r == "b/c")
			return "Both Broadleaved and Conifer";
		else
			return "Unknown";

	});
	const runningCalculations = computed (() => { return pwaStore.runningCalculations; });
	// const canSubmit = computed(() => {
	// 	return surveyStore.canSubmit(props.survey) && checkAllValidated.value;
	// });
	const habitatType = computed(() => {
		return JSON.parse(props.survey.survey_data).habitat_type;
	});
	const parcelIdentifier = computed(() => {
		return JSON.parse(props.survey.survey_data).parcel;
	});
	const checkAllValidated = computed(() => {
		return preAssessmentValid.value && walkAssessmentValid.value && allPlotsValid.value;
	});
	const preAssessmentValid = computed(() => {
		const preSurvey = new Model(preAssessmentSurveyJson);
		// Restore survey results
		const prevData = props.survey.survey_data;
		if (prevData) {
			const data = JSON.parse(prevData);
			preSurvey.data = data;
		}
		return preSurvey.validate();
	});
	const walkAssessmentValid = computed(() => {
		const walksurvey = new Model(woodlandSurveyJson);
		// Restore survey results
		const prevData = props.survey.survey_data;
		if (prevData) {
			const data = JSON.parse(prevData);
			walksurvey.data = data;
		}
		return walksurvey.validate();
	});

	async function exportForestLab () {
		// eslint-disable-next-line no-inline-comments
		const url = new URL("/api/single_export", window.location.origin); // Replace with your Laravel app URL
		url.searchParams.append("woodland_survey_id", props.survey.id);

		props.survey.xls_string = getXLSString(props.survey);
		await woodlandSurveyStore.update(props.survey);

		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Accept": "application/json"
				}
			});

			if (response.ok) {
				const blob = await response.blob();
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = url;
				link.download = "exported_data.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} else {
				console.error("Error downloading file:", response.statusText);
			}
		} catch (error:any) {
			console.error("Error:", error.message);
		}

	}

	const invalidPlots = ref<any[]>([]);
	function calcInvalidPlots (survey: any = surveyById.value) {
		let invalidPlotStrings:any[] = [];
		let i = 0;
		if (survey?.plot_surveys && survey.plot_surveys.length > 0) {
			for (const p of survey.plot_surveys.sort((a: PlotSurvey, b: PlotSurvey) => (a["created_at"] > b["created_at"] ? 1 : -1))) {
				i++;
				const pPrevData = p.survey_data;
				let plotValid = plot_valid(p);

				if (!plotValid) invalidPlotStrings.push(
					{ name: (JSON.parse(pPrevData)?.location_descriptor ? " - " + JSON.parse(pPrevData)?.location_descriptor : ""),
						link: "/editsurvey/" + survey.id + "/" + props.siteId + "/" + props.estateId + "/" + props.clientId + "/menu1/" + p.id + "_accordion_item",
						created_at: p.created_at, index: i });
			}
		}
		// console.log("invalidPlotStrings",invalidPlotStrings);
		return invalidPlotStrings;
	}
	function oldPlots (survey: any = surveyById.value) {
		let oldPlot = false;
		// TODO UPDATE CUTOFF POINT: 1st April 2025
		const cutoffDate = new Date("2025-04-01");
		if (survey?.plot_surveys && survey.plot_surveys.length > 0) {
			for (const p of survey.plot_surveys) {
				if (new Date(p.created_at) < cutoffDate) return true;
			}
		}
		return oldPlot;
	}
	function plot_valid (p: any) {
		const psurvey = new Model(plotSurveyJson);
		const pPrevData = p.survey_data;
		if (pPrevData) {
			const data = JSON.parse(pPrevData);
			psurvey.data = data;
		}
		let plotValid = psurvey.validate();
		return plotValid;
	}
	const allPlotsValid = computed(() => {
		return invalidPlots.value.length == 0;
	});

	const isOnMultipleDevices = computed(() => {
		return alertStore.isAlerting("Are you using more than one device simultaneously? This can cause data loss. Click on your profile icon to log out all other devices aside from this one.");
	});
	watch(isOnMultipleDevices, (newValue, oldValue) => {
		if (oldValue === true && newValue === false) {
			loadData();
		}
	});

	// Re-derive everything whenever the underlying survey is refreshed. A multi-device
	// sync (authStore.getCurrentUser) swaps the store objects, so surveyById resolves
	// to a new object and its plot list / timestamps change - without this the
	// displayed errors, warnings and score keep showing pre-sync values.
	watch(
		() => [
			surveyById.value?.id,
			surveyById.value?.updated_at,
			surveyById.value?.synced_at,
			surveyById.value?.survey_data,
			surveyById.value?.plot_surveys?.length
		],
		() => loadData()
	);

	onMounted(() => {
		loadData();
	});
	function loadData () {
		// Derive every value below from a single, freshly-resolved survey object so
		// they stay consistent. Previously errors/warnings read a stale captured
		// reference while the score read props.survey, so they drifted apart whenever
		// another device triggered a store refresh.
		const activeSurvey: any = surveyById.value;
		if (!activeSurvey) return;
		// reorder the plots by created_at
		if (activeSurvey.plot_surveys)
			activeSurvey.plot_surveys = activeSurvey.plot_surveys.sort((a: PlotSurvey, b: PlotSurvey) => (a["created_at"] > b["created_at"] ? 1 : -1));
		errors.value = getErrors(activeSurvey);
		warnings.value = getWarnings(activeSurvey);
		invalidPlots.value = calcInvalidPlots(activeSurvey);
		provisional_survey_score.value = runCalculation(activeSurvey);
		if (pwaStore.version == 2 && oldPlots(activeSurvey)) alertStore.warn("One or more of your plots for the survey ''" + activeSurvey.name + "' at '" + (site.value?.name ?? "") + "' was created before version 2 of the Woodland Condition Assessment application was launched. It is advised that you check the plot locations for any inaccuracies.");
	}
	const route = useRoute();
	// Watch route changes (e.g. when navigating back here) and reset warings etc
	watch(
		() => route.fullPath,
		() => {
			loadData();
		}
	);

	async function submitSurvey (survey: any) {
		props.survey.complete = 1;
		props.survey.xls_string = getXLSString(survey);
		await woodlandSurveyStore.update(props.survey);
	}

	const provisional_survey_score:any = ref(null);
	function runCalculation (survey: any = surveyById.value) {
		console.log("running calculation..");
		pwaStore.startRunningCalculations();
		let X: any;
		if (JSON.parse(survey.survey_data).survey_type == "wca")
			X = (scoreSurvey_WCA(survey) || null);
		else X = (scoreSurvey_BNG(survey) || null);
		pwaStore.stopRunningCalculations();
		console.log("done");
		// provisional_survey_score.value = X;
		return X;
	}

	function score2String (score:number|undefined) {
		if (typeof score === "undefined")
			return "";
		if (JSON.parse(props.survey.survey_data).survey_type == "wca") {
			if (score > 45 || score < 15)
				return scoreString[0];
			else if (score > 35)
				return scoreString[3];
			else if (score >= 26)
				return scoreString[2];
			else
				return scoreString[1];
		}
		else {
			if (score > 43 || score < 13)
				return scoreString[0];
			else if (score > 32)
				return scoreString[3];
			else if (score >= 26)
				return scoreString[2];
			else
				return scoreString[1];

		}
	}

	function capitalise (word: string) {
		return word.charAt(0).toUpperCase()
			+ word.slice(1);
	}
	function titleCase (str: string) {
		var splitStr = str.toLowerCase().split(" ");
		for (var i = 0; i < splitStr.length; i++) {
			splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
		}
		return splitStr.join(" ");
	}

	function drawCentredText (page:any, text:string, y:number, fontSize:number, pdfFont:any, color:any) {

		let textWidth = pdfFont.widthOfTextAtSize(text, fontSize);
		let textHeight = pdfFont.heightAtSize(fontSize);
		page.drawText(text, {
			x: page.getWidth() / 2 - textWidth / 2,
			y: y,
			size: fontSize,
			font: pdfFont,
			color: color
		});
		return;
	}

	async function addPage (pdfDoc:PDFDocument, footerText:string|null = null, fontSize = 20, lineSpace = 1.5) {
		const page = pdfDoc.addPage();
		let y = 24;
		if (!footerText) {
			// footerText = "logos:FC, FSC, Sylva Foundation, Woodland Trust";

			const logoHeight = 20;
			// y -= logoHeight + fontSize * 1.5;
			const spacer = fontSize * 1;

			// FIRST ROW
			// Fetch JPEG image
			let jpgUrl = "/logos/fc_linear_col.jpg";
			let jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer());

			let jpgImageL = await pdfDoc.embedJpg(jpgImageBytes);
			let jpgDimsL = jpgImageL.scale(0.25);
			let logoWidthL = logoHeight * jpgDimsL.width / jpgDimsL.height;

			// Fetch JPEG image
			jpgUrl = "/logos/NatEng_logo_New-Green.jpg";
			jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer());

			let jpgImageM = await pdfDoc.embedJpg(jpgImageBytes);
			let jpgDimsM = jpgImageM.scale(0.25);
			let logoWidthM = logoHeight * jpgDimsM.width / jpgDimsM.height;

			// Fetch JPEG image
			jpgUrl = "/logos/woodland_trust.jpg";
			jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer());

			let jpgImageR = await pdfDoc.embedJpg(jpgImageBytes);
			let jpgDimsR = jpgImageR.scale(0.25);
			let logoWidthR = logoHeight * jpgDimsR.width / jpgDimsR.height;

			// SECOND ROW
			// Fetch JPEG image
			jpgUrl = "/logos/fsc-logo-tree-green-rgb.jpg";
			jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer());

			let jpgImageL2 = await pdfDoc.embedJpg(jpgImageBytes);
			let jpgDimsL2 = jpgImageL2.scale(0.25);
			let logoWidthL2 = logoHeight * jpgDimsL2.width / jpgDimsL2.height;

			// Fetch JPEG image
			jpgUrl = "/logos/Sylva_logo_RGB_rectangular_large.jpg";
			jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer());

			let jpgImageR2 = await pdfDoc.embedJpg(jpgImageBytes);
			let jpgDimsR2 = jpgImageR2.scale(0.25);
			let logoWidthR2 = logoHeight * jpgDimsR2.width / jpgDimsR2.height;

			// Fetch JPEG image
			jpgUrl = "/logos/FRlogo_linear_colour_white box.jpg";
			jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer());

			let jpgImageM2 = await pdfDoc.embedJpg(jpgImageBytes);
			let jpgDimsM2 = jpgImageM2.scale(0.25);
			let logoWidthM2 = logoHeight * jpgDimsM2.width / jpgDimsM2.height;

			let totalWidth = logoWidthL + logoWidthM + logoWidthR + logoWidthL2 + logoWidthM2 + logoWidthR2 + 5 * spacer;

			page.drawImage(jpgImageL, {
				x: page.getWidth() / 2 - totalWidth / 2,
				y: y,
				width: logoWidthL,
				height: logoHeight
			});
			page.drawImage(jpgImageM, {
				x: page.getWidth() / 2 - totalWidth / 2 + spacer + logoWidthL,
				y: y,
				width: logoWidthM,
				height: logoHeight
			});
			page.drawImage(jpgImageR, {
				x: page.getWidth() / 2 - totalWidth / 2 + spacer + logoWidthL + spacer + logoWidthM,
				y: y,
				width: logoWidthR,
				height: logoHeight
			});
			page.drawImage(jpgImageL2, {
				x: page.getWidth() / 2 - totalWidth / 2 + spacer + logoWidthL + spacer + logoWidthM + spacer + logoWidthR,
				y: y,
				width: logoWidthL2,
				height: logoHeight
			});
			page.drawImage(jpgImageM2, {
				x: page.getWidth() / 2 - totalWidth / 2 + spacer + logoWidthL + spacer + logoWidthM + spacer + logoWidthR + spacer + logoWidthL2,
				y: y,
				width: logoWidthM2,
				height: logoHeight
			});
			page.drawImage(jpgImageR2, {
				x: page.getWidth() / 2 - totalWidth / 2 + spacer + logoWidthL + spacer + logoWidthM + spacer + logoWidthR + spacer + logoWidthL2 + spacer + logoWidthM2,
				y: y,
				width: logoWidthR2,
				height: logoHeight
			});
		}
		else drawCentredText(page, footerText, 24, 10, pdfFont, rgb(0.5, 0.5, 0.5));
		return page;
	}

	async function my_layoutMultilineText (pdfDoc: PDFDocument, page:PDFPage, startingPositon:number, text:string, lineSpace:number|null = null) {
		const fontSize = 9;
		let height = startingPositon;
		const multiText = layoutMultilineText(
			text,
			{
				alignment: TextAlignment.Left,
				font: pdfFont,
				fontSize: fontSize,
				bounds: {
					x: marginLeft,
					y: startingPositon,
					width: page.getWidth() - marginLeft - marginRight,
					height: page.getHeight() - headerHeight - footerHeight
				}
			});

		if (!lineSpace) lineSpace = 1.5;
		const lineHeight = lineSpace * fontSize;
		// startingPositon = cellStartY - table.rowHeight - 20 - 20;
		for (let i = 0; i < multiText.lines.length; i++) {
			if ((startingPositon) < footerHeight) {
				page = await addPage(pdfDoc);
				page.setFont(pdfFont);
				// reset starting position
				startingPositon = page.getHeight() - headerHeight;
				height = page.getHeight() - headerHeight;
			}
			page.drawText(`${multiText.lines[i].text}`, {
				x: marginLeft,
				y: startingPositon,
				size: fontSize,
				maxWidth: page.getWidth() - marginLeft - marginRight,
				color: rgb(0, 0, 0),
				font: pdfFont
			});
			// move position down
			startingPositon = startingPositon - (lineHeight);
		}
		height = height - startingPositon;
		return height;
	}

	let pdfFont:PDFFont, pdfFontBold:PDFFont, pdfFontBoldOblique:PDFFont, headerHeight:number, footerHeight:number, marginLeft:number, marginRight:number;

	async function generatePDF () {
		if (JSON.parse(props.survey?.survey_data)?.survey_type == "bng")
			generateReport("bng");
		else if (JSON.parse(props.survey?.survey_data)?.survey_type == "wca")
			generateReport("wca");
		else
			console.log("report type unknown");
	}
	async function generateReport (report_type:string) {
		if (provisional_survey_score.value == null) return;
		// Create a new PDF document
		const pdfDoc = await PDFDocument.create();

		// Embed the Times Roman font
		// const pdfFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
		pdfFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
		pdfFontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
		pdfFontBoldOblique = await pdfDoc.embedFont(StandardFonts.HelveticaBoldOblique);
		headerHeight = 50;
		footerHeight = 50;
		marginLeft = marginRight = 50;

		let lineSpace = 1.5;

		let page = await addPage(pdfDoc);
		const { width, height } = page.getSize();
		let fontSize = 20;

		let titleText = trans("global.report.title_" + report_type).toUpperCase();
		let subTitleText = trans("global.report.subtitle_" + report_type).toUpperCase();

		const appEdition = import.meta.env.VITE_APP_EDITION;

		let textWidth = pdfFont.widthOfTextAtSize(titleText, fontSize);
		const textHeight = pdfFont.heightAtSize(fontSize);

		const titleColor = rgb(0, 0.53, 0.71);
		let y = page.getHeight() - 4 * fontSize;
		drawCentredText(page, titleText, y, fontSize, pdfFont, titleColor);
		y -= fontSize *  lineSpace;
		drawCentredText(page, subTitleText, y, fontSize, pdfFont, titleColor);
		if (appEdition) {
			y -= fontSize *  lineSpace;
			drawCentredText(page, appEdition, y, fontSize, pdfFont, rgb(1, 0, 0));
		}

		y = y - 2 * fontSize;
		fontSize = 12;
		const fontColor = rgb(0, 0, 0);
		drawCentredText(page, trans("global.report.woodland_name_title_" + report_type), y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.site + (report_type == "wca" ? "" : " - " + trans("global.report.habitat_type_" + JSON.parse(props.survey.survey_data).habitat_type) + " - " + JSON.parse(props.survey.survey_data).parcel), y, fontSize, pdfFont, fontColor);
		y -= fontSize * 2;
		drawCentredText(page, "Location", y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.gridref, y, fontSize, pdfFont, fontColor);
		y -= fontSize * 2;

		// optional
		if (report_type == "bng") {
			props.sbi ? drawCentredText(page, "Parcel Size", y, fontSize, pdfFontBold, fontColor) : null;
			y -= fontSize * 1.5;
			props.sbi ? drawCentredText(page, JSON.parse(props.survey.survey_data).question14a + "ha", y, fontSize, pdfFont, fontColor) : null;
			y -= fontSize * 2;
		}
		if (props.sbi) {
			drawCentredText(page, "Single Business Identifier", y, fontSize, pdfFontBold, fontColor);
			y -= fontSize * 1.5;
			// }
			// if (props.sbi) {
			drawCentredText(page, props.sbi, y, fontSize, pdfFont, fontColor);
			y -= fontSize * 2;
		}

		if (report_type == "wca") {
			if (props.htr) {
				drawCentredText(page, "Higher Tier Reference", y, fontSize, pdfFontBold, fontColor);
				y -= fontSize * 1.5;
				drawCentredText(page, props.htr, y, fontSize, pdfFont, fontColor);
				y -= fontSize * 2;
			}
			if (props.wmp) {
				drawCentredText(page, "Woodland Management Plan", y, fontSize, pdfFontBold, fontColor);
				y -= fontSize * 1.5;
				drawCentredText(page, props.wmp, y, fontSize, pdfFont, fontColor);
				y -= fontSize * 2;
			}

			// areas
			drawCentredText(page, "Size of woodland (or woodland parcel)", y, fontSize, pdfFontBold, fontColor);
			y -= fontSize * 1.5;
			drawCentredText(page, "Total: " + JSON.parse(props.survey.survey_data).question14a + "ha", y, fontSize, pdfFont, fontColor);
			if (!(getWoodlandType(props.survey) == "c")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Broadleaved: " + JSON.parse(props.survey.survey_data).question14b + "ha", y, fontSize, pdfFont, fontColor);
			}
			if (!(getWoodlandType(props.survey) == "b")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Conifer: " + JSON.parse(props.survey.survey_data).question14c + "ha", y, fontSize, pdfFont, fontColor);
			}
		}

		fontSize = 20;

		titleText = trans("global.report.title_" + report_type).toUpperCase();
		subTitleText = trans("global.labels.score").toUpperCase();
		// textWidth = pdfFont.widthOfTextAtSize(titleText, fontSize);
		// textHeight = pdfFont.heightAtSize(fontSize);
		y = y - 3 * fontSize;

		fontSize = 18;
		drawCentredText(page, subTitleText, y, fontSize, pdfFont, titleColor);

		y = y - 2 * fontSize;
		fontSize = 12;
		drawCentredText(page, "Date of Assessment", y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.survey.assessment_date ? props.survey.assessment_date : "", y, fontSize, pdfFont, fontColor);
		y -= fontSize * 2;
		drawCentredText(page, "Completed by", y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.survey.surveyor_name, y, fontSize, pdfFont, fontColor);

		// Scores
		y -= fontSize * 2;
		drawCentredText(page, "Score(s)", y, fontSize, pdfFontBold, fontColor);
		if (report_type == "wca") {
			if (!(getWoodlandType(props.survey) == "c")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Broadleaved: " + provisional_survey_score.value.b, y, fontSize, pdfFont, fontColor);
			}
			if (!(getWoodlandType(props.survey) == "b")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Conifer: " + provisional_survey_score.value.c, y, fontSize, pdfFont, fontColor);
			}
		}
		else {
			y -= fontSize * 1.5;
			drawCentredText(page, String(provisional_survey_score.value.m), y, fontSize, pdfFont, fontColor);
		}

		// Condition
		y -= fontSize * 2;
		drawCentredText(page, "Condition", y, fontSize, pdfFontBold, fontColor);

		if (report_type == "wca") {
			if (!(getWoodlandType(props.survey) == "c")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Broadleaved: " + score2String(provisional_survey_score. value.b), y, fontSize, pdfFont, fontColor);
			}
			if (!(getWoodlandType(props.survey) == "b")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Conifer: " + score2String(provisional_survey_score. value.c), y, fontSize, pdfFont, fontColor);
			}
		}
		else {
			y -= fontSize * 1.5;
			drawCentredText(page, score2String(provisional_survey_score. value.m), y, fontSize, pdfFont, fontColor);
		}

		let multiText = "";
		if (report_type == "bng") {
			if (JSON.parse(props.survey.survey_data)?.survey_notes) {
				y -= fontSize * 4.5;
				drawCentredText(page, "Survey Limitations:", y, fontSize, pdfFontBold, fontColor);
				y -= fontSize * 1.5;
				multiText = "Notes from surveyor: " + JSON.parse(props.survey.survey_data)?.survey_notes;
				// drawCentredText(page, multitext, y, fontSize, pdfFont, fontColor);
				my_layoutMultilineText(pdfDoc, page, y, multiText);
			}
		}

		// Add a new page
		page = await addPage(pdfDoc);

		fontSize = 9;

		page.drawText("About your " + trans("global.report.title_" + report_type) + " score", {
			x: marginLeft,
			y: page.getHeight() - headerHeight,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});

		multiText = "Your scores for each of the " + (report_type == "wca" ? "15" : "13") +
			" indicators of the " + trans("global.report.title_" + report_type) + " are provided below" +
			(report_type == "wca" ? ", separated by main habitat types (broadleaved or conifer) where present." : ".") +
			"\r  • POOR (1) indicates areas where significant improvements can be made to the condition of the habitat." +
			"\r  • MODERATE (2) indicates areas where some improvements can be made to the condition of the habitat." +
			"\r  • GOOD (3) indicates areas where habitat is in good condition, although there could still be room for " +
			"further improvement, and there may be ongoing managements requirements to maintain good condition.";
		let multiTextHeight = await  my_layoutMultilineText(pdfDoc, page, page.getHeight() - headerHeight - fontSize * lineSpace, multiText);
		let startingPositon = page.getHeight() - headerHeight - fontSize * lineSpace - multiTextHeight;

		// Define table properties
		let headerText = ["Indicator", "Score", ""];
		let headerText1 = ["", "", ""];
		let j_in = [0, 1];
		if (report_type == "wca") {
			headerText = ["Indicator", "Coniferous", "Broadleaved, Yew "];
			headerText1 = ["", "Woodland", "& Mixed Woodland"];
			if (getWoodlandType(props.survey) == "b") {
				j_in = [0, 2];
			}
			else if (getWoodlandType(props.survey) == "c") {
				j_in = [0, 1];
			}
			else {
				j_in = [0, 1, 2];
			}
		}
		let n_cols = j_in.length;
		const table = {
			startX: marginLeft,
			startY: startingPositon - (lineSpace * fontSize * 2),
			rowHeight: 20,
			colWidth: [width - marginLeft - marginRight - (n_cols - 1) * 100, 100, 100],
			numOfRows: provisional_survey_score. value.numQs,
			numOfCols: n_cols,
			borderWidth: 0.5,
			font: pdfFont,
			fontHeader: pdfFontBold,
			fontSize: 10
		};

		// Draw the table
		// headers
		let i = 0;
		let cellStartX = table.startX;
		let inds = "ABCDEFGHIJKLM";
		let inds_with_defaults = "ABCDEFxGHIJKLxM";
		// for (let j = 0; j < table.numOfCols; j++) {
		lineSpace = 1;
		for (let j of j_in) {
			// Calculate cell positions
			const x = cellStartX;
			const y = table.startY - i * table.rowHeight - (report_type == "wca" ? table.rowHeight : 0);
			// Draw cell borders
			page.drawRectangle({
				x,
				y,
				width: table.colWidth[j],
				height: table.rowHeight * (report_type == "wca" ? 2 : 1),
				borderColor: rgb(0, 0, 0),
				borderWidth: table.borderWidth
			});
			// Fill cell with content
			// Header row
			page.drawText(headerText[j], {
				// Add padding
				x: x + 5,
				// Adjust for text height
				y: y - table.fontSize + table.rowHeight * (report_type == "wca" ? 1.75 : 1),
				size: table.fontSize,
				font: table.fontHeader,
				color: rgb(0, 0, 0)
			});
			if (report_type == "wca")
				page.drawText(headerText1[j], {
					// Add padding
					x: x + 5,
					// Adjust for text height
					y: y - table.fontSize + table.rowHeight,
					size: table.fontSize,
					font: table.fontHeader,
					color: rgb(0, 0, 0)
				});
			cellStartX = cellStartX + table.colWidth[j];
		}
		lineSpace = 1.5;
		// content
		table.startY = table.startY - table.rowHeight * (report_type == "wca" ? 2 : 1);
		let cellStartY = table.startY;
		let cellHeight = table.rowHeight;
		let bng_offset = 0;

		for (let i = 0; i < provisional_survey_score.value.numQs; i++) {
			let cellStartX = table.startX;
			// if (report_type == "wca" || !(i == 6 || i == 13)) {
			if (report_type == "bng" && (i == 6 || i == 12)) bng_offset++;
			// for (let j = 0; j < table.numOfCols; j++) {
			for (let j of j_in) {
				// Calculate cell positions
				const x = cellStartX;
				// - (i+1) * table.rowHeight;
				let y = cellStartY;
				// Fill cell with content
				let cellText = "no info";
				if (j == 0) {
					// Data rows
					cellText = (report_type == "wca" ? String(i + 1) : inds[i]) + ". " + trans("wca.questions.question" + String(i + 1 + bng_offset) + (report_type == "wca" ? inds_with_defaults[i] : inds[i]).toLowerCase());
				}
				else if (j == 1) {
					// Data rows
					if (report_type == "wca")
						cellText = String(provisional_survey_score.value.advice_c[i][1].c);
					else
						cellText = String(provisional_survey_score.value.advice_m[i][1].m);
				}
				else if (j == 2 && report_type == "wca") {
					// Data rows
					cellText = String(provisional_survey_score.value.advice_b[i][1].b);
				}

				let x_offset = 0;
				let bound_width = table.colWidth[j];
				if (j > 0) {
					const textWidth = table.font.widthOfTextAtSize(cellText, fontSize);
					x_offset = table.colWidth[j] - 10 - (textWidth);
				}
				const multiText = layoutMultilineText(cellText, {
					alignment: j == 0 ? TextAlignment.Left : TextAlignment.Right,
					font: table.font,
					fontSize: fontSize,
					bounds: { x: 0, y: 0, width: table.colWidth[j], height: height - 100 }
				});

				let startingPositon = y - table.fontSize + table.rowHeight;
				let lineHeight = table.rowHeight;
				for (let i = 0; i < multiText.lines.length; i++) {
					if ((startingPositon) < 50) {
						page = await addPage(pdfDoc);
						page.setFont(pdfFont);
						// addFooter(page, logoImage, encounter, patient, doctor, patientUser, medFont)
						// reset starting position
						startingPositon = height - 100;
					}
					page.drawText(`${multiText.lines[i].text}`, {
						x: x + 5 + x_offset,
						y: startingPositon,
						size: table.fontSize,
						// maxWidth: table.colWidth[2],
						color: rgb(0, 0, 0),
						font: table.font
					});
					// move position down
					startingPositon = startingPositon - (lineHeight);
				}
				cellHeight =  Math.max(cellHeight, (y - table.fontSize + table.rowHeight) - startingPositon);
				y = table.startY - (i - 1) * table.rowHeight - cellHeight;

				// increment start X position
				cellStartX = cellStartX + table.colWidth[j];
			}

			cellStartX = table.startX;
			for (let j = 0; j < table.numOfCols; j++) {
				// Calculate cell positions
				const x = cellStartX;
				let y = cellStartY - cellHeight + table.rowHeight;

				// Draw cell borders
				page.drawRectangle({
					x,
					y,
					width: table.colWidth[j],
					height: cellHeight,
					borderColor: rgb(0, 0, 0),
					borderWidth: table.borderWidth
				});

				// increment start X position
				cellStartX = cellStartX + table.colWidth[j];
			}
			cellStartY = cellStartY - cellHeight;
			// }

		}
		// RESULTS
		cellStartX = table.startX;
		let footertextscore = [
			capitalise("total score"),
			String(report_type == "wca" ? provisional_survey_score. value.c : provisional_survey_score?. value.m) + "/" + (report_type == "wca" ? 45 : 39),
			String(provisional_survey_score. value.b) + "/" + (report_type == "wca" ? 45 : 39)];
		let footertextscondition = [
			capitalise("Condition"),
			score2String(report_type == "wca" ? provisional_survey_score. value.c : provisional_survey_score. value.m),
			score2String(provisional_survey_score. value.b)
		];
		for (let j of j_in) {
			// Calculate cell positions
			const x = cellStartX;
			const y = table.startY - (report_type == "wca" ? 15 : 13) * table.rowHeight;
			// Draw cell borders
			page.drawRectangle({
				x,
				y,
				width: table.colWidth[j],
				height: table.rowHeight,
				borderColor: rgb(0, 0, 0),
				borderWidth: table.borderWidth
			});
			// Fill cell with content
			// Header row

			let x_offset = 0;
			if (j > 0) {
				// align right
				const textWidth = table.fontHeader.widthOfTextAtSize(footertextscore[j], table.fontSize);
				x_offset = table.colWidth[j] - 10 - (textWidth);
			}
			page.drawText(footertextscore[j], {
				// Add padding
				x: x + 5 + x_offset,
				// Adjust for text height
				y: y - table.fontSize + table.rowHeight,
				size: table.fontSize,
				font: table.fontHeader,
				color: rgb(0, 0, 0)
			});
			cellStartX = cellStartX + table.colWidth[j];
		}
		cellStartX = table.startX;
		for (let j of j_in) {
			// Calculate cell positions
			const x = cellStartX;
			const y = table.startY - ((report_type == "wca" ? 15 : 13) + 1) * table.rowHeight;
			// Draw cell borders
			page.drawRectangle({
				x,
				y,
				width: table.colWidth[j],
				height: table.rowHeight,
				borderColor: rgb(0, 0, 0),
				borderWidth: table.borderWidth
			});
			// Fill cell with content
			// Header row
			let x_offset = 0;
			if (j > 0) {
				// align right
				const textWidth = table.fontHeader.widthOfTextAtSize(footertextscondition[j], table.fontSize);
				x_offset = table.colWidth[j] - 10 - (textWidth);
			}
			page.drawText(footertextscondition[j], {
				// Add padding
				x: x + 5 + x_offset,
				// Adjust for text height
				y: y - table.fontSize + table.rowHeight,
				size: table.fontSize,
				font: table.fontHeader,
				color: rgb(0, 0, 0)
			});
			cellStartX = cellStartX + table.colWidth[j];
		}
		let start = table.startY - ((report_type == "wca" ? 15 : 13) + 1) * table.rowHeight - 20;
		if (JSON.parse(props.survey.survey_data).innsnotes) {
			page.drawText("Invasive and non-native species (INNS) notes:", {
				x: marginLeft,
				y: start,
				size: fontSize,
				font: pdfFontBoldOblique,
				color: fontColor
			});
			start -= 2 * fontSize * lineSpace;
			let text = JSON.parse(props.survey.survey_data).innsnotes;
			multiTextHeight = await my_layoutMultilineText(pdfDoc, page, start, text);
			start -= multiTextHeight + fontSize * lineSpace;
		}

		// recommended actions on new page? uncomment next two lines
		// page = await addPage(pdfDoc);
		// start = page.getHeight() - headerHeight;
		let text = "";
		multiTextHeight = 0;
		page.drawText("Recommended actions", {
			x: marginLeft,
			y: start,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
		});
		start -= 2 * fontSize * lineSpace;

		if ((report_type == "wca" && (provisional_survey_score.value.advice_b[8][1].b == 1 || provisional_survey_score.value.advice_c[8][1].c == 1)) ||
			(report_type == "bng" && provisional_survey_score.value.advice_m[7][1].m == 1)) {
			page.drawText("Tree health", {
				x: marginLeft,
				y: start,
				size: fontSize,
				font: pdfFontBoldOblique,
				color: fontColor
			});
			start -= fontSize * lineSpace;
			text = "If you find evidence of any of these pests and diseases, take care not to spread them to " +
				"new places. Arrive with clean footwear, clean tools and footwear at end of each visit to prevent " +
				"accidental movement of invasive species, pests, and pathogens. Don't move infected wood between sites. A few pests " +
				"and diseases are notifiable. This means that you must by law report any sightings. The easiest way to " +
				"report is via TreeAlert: treealert.forestresearch.gov.uk";
			multiTextHeight = await my_layoutMultilineText(pdfDoc, page, start, text);
			start -= multiTextHeight + fontSize * lineSpace;
		}

		if ((report_type == "wca" && (provisional_survey_score.value.advice_b[2][1].b < 3 || provisional_survey_score.value.advice_c[2][1].c < 3)) ||
			(report_type == "bng" && provisional_survey_score.value.advice_m[2][1].m < 3)) {
			page.drawText("Invasive plant species", {
				x: marginLeft,
				y: start,
				size: fontSize,
				font: pdfFontBoldOblique,
				color: fontColor
			// alignment: TextAlignment.Left
			});
			start -= fontSize * lineSpace;
			text = "You should report listed plants to the Non-Native Species Secretariat. These include any "
				+ "plant species listed on Schedule 9 (https://www.legislation.gov.uk/ukpga/1981/69/schedule/9) " +
				"of the Wildlife and Countryside Act 1981. All non-native species " +
				"records are useful, helping to identify trends and track the distribution of over 1800 non-native " +
				"plants and animals.";
			multiTextHeight = await  my_layoutMultilineText(pdfDoc, page, start, text);
			start -= multiTextHeight + fontSize * lineSpace;
		}

		if ((report_type == "wca" && (provisional_survey_score.value.advice_b[11][1].b > 1 || provisional_survey_score.value.advice_c[11][1].c > 1)) ||
			(report_type == "bng" && provisional_survey_score.value.advice_m[11][1].m > 1)) {
			page.drawText("Veteran trees", {
				x: marginLeft,
				y: start,
				size: fontSize,
				font: pdfFontBoldOblique,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			start -= fontSize * lineSpace;
			text = "A veteran tree is of particular interest because of its age, size, condition and history. " +
				"These trees are important biologically, culturally, and aesthetically. Please record any veteran trees " +
				"by adding a record(s) with the Woodland Trust: Add a Record - Ancient Tree Inventory (https://ati.woodlandtrust.org.uk/add-a-tree/)";
			multiTextHeight = await  my_layoutMultilineText(pdfDoc, page, start, text);
			start -= multiTextHeight + fontSize * lineSpace;
		}

		page.drawText("Further information and guidance", {
			x: marginLeft,
			y: start,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		start -= fontSize * lineSpace;
		text = "  • the Woodland Wildlife Toolkit (https://woodlandwildlifetoolkit.sylva.org.uk/advice-management) " +
			"provides advice on managing woodlands for wildlife, " +
			"in particular rare and declining species that are dependent on woodland habitats.";
		my_layoutMultilineText(pdfDoc, page, start, text);

		// Add a new page
		page = await addPage(pdfDoc);

		fontSize = 9;

		page.drawText("Survey UUID: " + props.survey.id, {
			x: marginLeft,
			y: page.getHeight() - headerHeight,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});

		page.drawText("Plot locations for this survey", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * 2,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});

		multiText = "";
		i = 0;
		for (const p of props.survey.plot_surveys ?? []) {
			i++;
			const data = p.survey_data;
			const is_gps = JSON.parse(data)?.question0x == "gps";
			multiText += i +
				(is_gps ? " (Lon/Lat)" : " (Grid ref.)") + ": " +
				(is_gps ? JSON.parse(data)?.question10lon.toFixed(6) + ", " + JSON.parse(data)?.question10lat.toFixed(6) : JSON.parse(data)?.question12) +
				" - " + JSON.parse(data)?.location_descriptor + "\r";
		}
		my_layoutMultilineText(pdfDoc, page, page.getHeight() - headerHeight - fontSize * lineSpace - fontSize * 2, multiText);

		const pdfBytes = await pdfDoc.save();

		// After generating the PDF
		saveAs(new Blob([pdfBytes], { type: "application/pdf" }), report_type.toUpperCase() + "-report-" + props.site + "-" + props.survey.assessment_date + ".pdf");

		return pdfBytes;
	}

	async function incLineOrAddPage (line: number, pdfDoc: PDFDocument, page: PDFPage) {
		line++;
		if (line >= 55) {
			// Add a new page
			page = await addPage(pdfDoc);
			line = 0;
		}
		return [line, page] as const;
	}
	async function generateAnswersPDF_woodland () {
		let name = "Woodland walk";
		let survey_to_render = props.survey;
		const report_type = JSON.parse(props.survey?.survey_data)?.survey_type;
		const data = JSON.parse(survey_to_render.survey_data);

		// Create a new PDF document
		const pdfDoc = await PDFDocument.create();

		pdfFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
		pdfFontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
		pdfFontBoldOblique = await pdfDoc.embedFont(StandardFonts.HelveticaBoldOblique);
		headerHeight = 50;
		footerHeight = 50;
		marginLeft = marginRight = 50;

		let lineSpace = 1.5;

		let page = await addPage(pdfDoc);
		const { width, height } = page.getSize();
		let fontSize = 20;

		let titleText = ("Woodland responses").toUpperCase();
		let subTitleText = "Preassessment and woodland walk";
		let textWidth = pdfFont.widthOfTextAtSize(titleText, fontSize);
		const textHeight = pdfFont.heightAtSize(fontSize);

		const titleColor = rgb(0, 0.53, 0.71);
		let y = page.getHeight() - 4 * fontSize;
		drawCentredText(page, titleText, y, fontSize, pdfFont, titleColor);
		y -= fontSize;
		drawCentredText(page, subTitleText, y, fontSize, pdfFont, titleColor);

		y = y - 2 * fontSize;
		fontSize = 12;
		const fontColor = rgb(0, 0, 0);
		drawCentredText(page, trans("global.report.woodland_name_title_" + report_type), y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.site + (report_type == "wca" ? "" : " - " + trans("global.report.habitat_type_" + JSON.parse(props.survey.survey_data).habitat_type) + " - " + JSON.parse(props.survey.survey_data).parcel), y, fontSize, pdfFont, fontColor);
		y -= fontSize * 2;
		drawCentredText(page, "Location", y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.gridref, y, fontSize, pdfFont, fontColor);
		y -= fontSize * 2;

		const w_size = JSON.parse(props.survey.survey_data).question14a;
		// optional
		if (report_type !== "wca") {
			props.sbi ? drawCentredText(page, "Woodland Parcel Size", y, fontSize, pdfFontBold, fontColor) : null;
			y -= fontSize * 1.5;
			props.sbi ? drawCentredText(page, w_size ? w_size + "ha" : "No response", y, fontSize, pdfFont, fontColor) : null;
			y -= fontSize * 2;
		}

		if (report_type == "wca") {

			// areas
			drawCentredText(page, "Woodland Size", y, fontSize, pdfFontBold, fontColor);
			y -= fontSize * 1.5;
			drawCentredText(page, "Total: " + w_size ? w_size + "ha" : "No response", y, fontSize, pdfFont, fontColor);
			if (!(getWoodlandType(props.survey) == "c")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Broadleaved: " + JSON.parse(props.survey.survey_data).question14b + "ha", y, fontSize, pdfFont, fontColor);
			}
			if (!(getWoodlandType(props.survey) == "b")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Conifer: " + JSON.parse(props.survey.survey_data).question14c + "ha", y, fontSize, pdfFont, fontColor);
			}
		}

		// Add a new page
		page = await addPage(pdfDoc);

		fontSize = 9;
		let line = 0;

		[line, page] = await  incLineOrAddPage(line, pdfDoc, page);
		page.drawText("1|A Age distribution of trees", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Age classes present", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		if (typeof data.question1 !== "undefined") {
			for (const item of data.question1) {
				page.drawText(titleCase(item), {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
					// alignment: TextAlignment.Left
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
		}
		else {
			page.drawText("No response", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("3|C Invasive plant species", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Are any invasive species present in this woodland?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data.question3b !== "undefined" ? (data.question3b ? "Yes" : "No") : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		if ((typeof data.question3b !== "undefined") && data.question3b) {
			if (data?.invasives) {
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				if (data?.invasives.indexOf("lysichiton_americanus") > -1) {
					page.drawText("American skunk cabbage", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("impatiens_glandulifera") > -1) {
					page.drawText("Himalayan balsam", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("fallopia_japonica") > -1) {
					page.drawText("Japanese knotweed", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("prunus_laurocerasus") > -1) {
					page.drawText("Cherry Laurel", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("gaultheria_shallon") > -1) {
					page.drawText("Shallon", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("symphoricarpos_albus") > -1) {
					page.drawText("Snowberry", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("lamiastrum_galeobdolon") > -1) {
					page.drawText("Variegated yellow archangel", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("rhododendron_ponticum") > -1) {
					page.drawText("Rhododendron", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.invasives.indexOf("other") > -1) {
					page.drawText("Other", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
			}
			else {
				page.drawText("No species selected", {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
					// alignment: TextAlignment.Left
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}

			if (data?.innsnotes) {
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				page.drawText("Indicate any other invasive or Schedule 9 species:", {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFontBold,
					color: fontColor
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);

				let multiTextHeight = await my_layoutMultilineText(
					pdfDoc, page,
					page.getHeight() - headerHeight - fontSize * lineSpace * line,
					typeof data?.innsnotes !== "undefined" ? (String(data.innsnotes)) : "None");
				line = line + multiTextHeight / (9 * lineSpace);
			}
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("6|F Open space within woodland", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Percentage of the woodland (or woodland parcel) is open space", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data.question6 !== "undefined" ? String(data.question6) + "%" : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		if (report_type == "wca") {
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			page.drawText("7 Proportion of favourable land cover", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize + 2,
				font: pdfFontBold,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			page.drawText("Percentage of favourable land cover is there within 5.6km of the woodland boundary", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFontBold,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			page.drawText(typeof data.question7 !== "undefined" ? String(data.question7) + "%" : "No response", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("12|K Veteran trees", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Number of veteran trees noted on the woodland walk", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data.question12 !== "undefined" ? String(data.question12) : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		// [line, page] = await incLineOrAddPage(line, pdfDoc, page);
		// [line, page] = await incLineOrAddPage(line, pdfDoc, page);
		// page.drawText("13|L Deadwood", {
		// 	x: marginLeft,
		// 	y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
		// 	size: fontSize + 2,
		// 	font: pdfFontBold,
		// 	color: fontColor
		// 	// alignment: TextAlignment.Left
		// });
		// [line, page] = await incLineOrAddPage(line, pdfDoc, page);
		// [line, page] = await incLineOrAddPage(line, pdfDoc, page);
		// page.drawText("Select the proportion of standing deadwood/large branches and stems that is continuously visible oer the woodland.", {
		// 	x: marginLeft,
		// 	y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
		// 	size: fontSize,
		// 	font: pdfFontBold,
		// 	color: fontColor
		// 	// alignment: TextAlignment.Left
		// });
		// [line, page] = await incLineOrAddPage(line, pdfDoc, page);
		// page.drawText("walk.", {
		// 	x: marginLeft,
		// 	y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
		// 	size: fontSize,
		// 	font: pdfFontBold,
		// 	color: fontColor
		// 	// alignment: TextAlignment.Left
		// });
		// [line, page] = await incLineOrAddPage(line, pdfDoc, page);
		// page.drawText(typeof data.question12 !== "undefined" ? data.question13 : "No response", {
		// 	x: marginLeft,
		// 	y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
		// 	size: fontSize,
		// 	font: pdfFont,
		// 	color: fontColor
		// 	// alignment: TextAlignment.Left
		// });
		// [line, page] = await incLineOrAddPage(line, pdfDoc, page);

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("15|M Woodland disturbance", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Describe any evidence of significant nutrient enrichment across the woodland", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		if (typeof data.question15 !== "undefined") {
			for (const item of data.question15) {
				let text = item == "significant" ? "There is evidence of significant nutrient enrichment across the woodland" : (item == ">1ha" ? "A patch (or sum of patches) of nutrient enrichment exceeds one hectare" : (item == "damage>20%" ? "More than 20% of woodland area has soil damage" : (item == "damage" ? "There is evidence of damaged ground across the woodland" : "No response")));
				page.drawText((text), {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
					// alignment: TextAlignment.Left
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
		}
		else {
			page.drawText("No response", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
				// alignment: TextAlignment.Left
			});
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Any further survey notes for this walk", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		let multiTextHeight = await my_layoutMultilineText(
			pdfDoc, page,
			page.getHeight() - headerHeight - fontSize * lineSpace * line,
			typeof data?.survey_notes !== "undefined" ? (String(data.survey_notes)) : "None");
		line = line +  multiTextHeight / (9 * lineSpace);

		const pdfBytes = await pdfDoc.save();

		// After generating the PDF
		saveAs(new Blob([pdfBytes], { type: "application/pdf" }), name + "-" + props.survey.assessment_date + ".pdf");

		return pdfBytes;
	}
	async function generateAnswersPDF_plots (survey_to_render: any, plot_num: number, name = "Raw") {
		const report_type = JSON.parse(props.survey?.survey_data)?.survey_type;
		const data = JSON.parse(survey_to_render.survey_data);

		// Create a new PDF document
		const pdfDoc = await PDFDocument.create();

		pdfFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
		pdfFontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
		pdfFontBoldOblique = await pdfDoc.embedFont(StandardFonts.HelveticaBoldOblique);
		headerHeight = 50;
		footerHeight = 50;
		marginLeft = marginRight = 50;

		let lineSpace = 1.5;

		let page = await addPage(pdfDoc);
		const { width, height } = page.getSize();
		let fontSize = 20;

		let titleText = ("Plot " + plot_num + " responses").toUpperCase();
		let subTitleText = ((typeof data.location_descriptor !== "undefined") ? data.location_descriptor : "");
		let textWidth = pdfFont.widthOfTextAtSize(titleText, fontSize);
		const textHeight = pdfFont.heightAtSize(fontSize);

		const titleColor = rgb(0, 0.53, 0.71);
		let y = page.getHeight() - 4 * fontSize;
		drawCentredText(page, titleText, y, fontSize, pdfFont, titleColor);
		y -= fontSize;
		// dont draw this here in case it's too long (used plot # instead)
		// drawCentredText(page, subTitleText, y, fontSize, pdfFont, titleColor);

		y = y - 2 * fontSize;
		fontSize = 12;
		const fontColor = rgb(0, 0, 0);
		drawCentredText(page, trans("global.report.woodland_name_title_" + report_type), y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.site + (report_type == "wca" ? "" : " - " + trans("global.report.habitat_type_" + JSON.parse(props.survey.survey_data).habitat_type) + " - " + JSON.parse(props.survey.survey_data).parcel), y, fontSize, pdfFont, fontColor);
		y -= fontSize * 2;
		drawCentredText(page, "Location", y, fontSize, pdfFontBold, fontColor);
		y -= fontSize * 1.5;
		drawCentredText(page, props.gridref, y, fontSize, pdfFont, fontColor);
		y -= fontSize * 2;

		// optional
		if (report_type !== "wca") {
			props.sbi ? drawCentredText(page, "Parcel Size", y, fontSize, pdfFontBold, fontColor) : null;
			y -= fontSize * 1.5;
			props.sbi ? drawCentredText(page, JSON.parse(props.survey.survey_data).question14a + "ha", y, fontSize, pdfFont, fontColor) : null;
			y -= fontSize * 2;
		}

		if (report_type == "wca") {

			// areas
			drawCentredText(page, "Size of Woodland" + (report_type == "bng" ? " Parcel" : ""), y, fontSize, pdfFontBold, fontColor);
			y -= fontSize * 1.5;
			drawCentredText(page, "Total: " + JSON.parse(props.survey.survey_data).question14a + "ha", y, fontSize, pdfFont, fontColor);
			if (!(getWoodlandType(props.survey) == "c")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Broadleaved: " + JSON.parse(props.survey.survey_data).question14b + "ha", y, fontSize, pdfFont, fontColor);
			}
			if (!(getWoodlandType(props.survey) == "b")) {
				y -= fontSize * 1.5;
				drawCentredText(page, "Conifer: " + JSON.parse(props.survey.survey_data).question14c + "ha", y, fontSize, pdfFont, fontColor);
			}
		}

		// Add a new page
		page = await addPage(pdfDoc);

		fontSize = 9;

		// location
		let line = 0;
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Location type", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(data.question0x == "gps" ? "GPS" : (data.question0x == "gridref" ? "Grid reference" : ""), {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(data.question0x == "gps" ? "Lat: " + data?.question10lat + ", Lon: " + data?.question10lon : (data.question0x == "gridref" ? data?.question12 : ""), {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Description", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		let multiTextHeight = await my_layoutMultilineText(
			pdfDoc, page,
			page.getHeight() - headerHeight - fontSize * lineSpace * line,
			typeof data.location_descriptor !== "undefined" ? (String(data.location_descriptor)) : "");
		line = line + multiTextHeight / (9 * lineSpace);
		// page.drawText(typeof data.location_descriptor !== "undefined" ? data.location_descriptor : "", {
		// 	x: marginLeft,
		// 	y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
		// 	size: fontSize,
		// 	font: pdfFont,
		// 	color: fontColor
		// 	// alignment: TextAlignment.Left
		// });
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		// Predominant woodland type if WCA
		if (report_type == "wca") {
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			page.drawText("Predominant woodland type within survey", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFontBold,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			page.drawText(data?.question1 == "b" ? "Broadleaved, mixed and yew woodland" : (data?.question1 == "c" ? "Coniferous woodland" : ""), {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Any further survey notes for this plot", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		multiTextHeight = await my_layoutMultilineText(
			pdfDoc, page,
			page.getHeight() - headerHeight - fontSize * lineSpace * line,
			typeof data?.question34 !== "undefined" ? (String(data.question34)) : "None");
		line = line + multiTextHeight / (9 * lineSpace);

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("2|B Wild, domestic and feral herbivore damage", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Is there evidence of significant browsing pressure within the survey plot?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(data?.question2 !== "undefined" ? (data.question2 ? "Yes" : "No") : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("3|C Invasive plant species", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Are any invasive species present in this plot?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data.question15 !== "undefined" ? (data.question15 ? "Yes" : "No") : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		if ((typeof data.question15 !== "undefined") && data.question15) {
			if (data?.question15) {
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				if (data?.question3.indexOf("lysichiton_americanus") > -1) {
					page.drawText("American skunk cabbage " + (data?.question3_1 ? " - " + data.question3_1 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("impatiens_glandulifera") > -1) {
					page.drawText("Himalayan balsam " + (data?.question3_2 ? " - " + data.question3_2 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("fallopia_japonica") > -1) {
					page.drawText("Japanese knotweed " + (data?.question3_3 ? " - " + data.question3_3 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("prunus_laurocerasus") > -1) {
					page.drawText("Cherry Laurel " + (data?.question3_4 ? " - " + data.question3_4 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("gaultheria_shallon") > -1) {
					page.drawText("Shallon " + (data?.question3_5 ? " - " + data.question3_5 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("symphoricarpos_albus") > -1) {
					page.drawText("Snowberry " + (data?.question3_6 ? " - " + data.question3_6 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("lamiastrum_galeobdolon") > -1) {
					page.drawText("Variegated yellow archangel " + (data?.question3_7 ? " - " + data.question3_7 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("rhododendron_ponticum") > -1) {
					page.drawText("Rhododendron " + (data?.question3_8 ? " - " + data.question3_8 + "%" : ""), {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
				if (data?.question3.indexOf("other") > -1) {
					page.drawText("Other", {
						x: marginLeft,
						y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
						size: fontSize,
						font: pdfFont,
						color: fontColor
						// alignment: TextAlignment.Left
					});
					[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				}
			}
			if (data?.innsnotes) {
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
				page.drawText("Indicate any other invasive or Schedule 9 species:", {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFontBold,
					color: fontColor
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);

				let multiTextHeight = await my_layoutMultilineText(
					pdfDoc, page,
					page.getHeight() - headerHeight - fontSize * lineSpace * line,
					typeof data?.innsnotes !== "undefined" ? (String(data.innsnotes)) : "None");
				line = line + multiTextHeight / (9 * lineSpace);
			}
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("4|D Number of native tree and shrub species", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Native trees and shrubs:", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		if (typeof data.question4 !== "undefined") {
			for (const item of data.question4) {
				page.drawText(titleCase(item), {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
					// alignment: TextAlignment.Left
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
			if (!data.question4 || data.question4.length == 0) {
				page.drawText("None", {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
		}
		else {
			page.drawText("None", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		}
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Non-native species:", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		if (typeof data.question9 !== "undefined") {
			for (const item of data.question9) {
				page.drawText(titleCase(item), {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
					// alignment: TextAlignment.Left
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
			if (!data.question4 || data.question4.length == 0) {
				page.drawText("None", {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
		}
		else {
			page.drawText("None", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("5|E Cover of native tree and shrub species", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Percentage of the canopy cover in the upper and understorey layers that is made up of native tree species ", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("within this survey plot's boundaries.", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data.question5 !== "undefined" ? String(data.question5) + "%" : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("8|G Woodland regeneration", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Size classes present", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		if (data?.question8)
			for (const item of data.question8) {
				const text = item == "Item 1" ? "Young trees: 4-7cm DBH" : (item == "Item 2" ? "Saplings: young trees that have not reached 4-7 cm DBH" : (item == "Item 4" ? "Seedlings (from seeds that have germinated this year) or advanced coppice growth (sprouting from stumps)" : ("None")));
				page.drawText(text, {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
					// alignment: TextAlignment.Left
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
		else {
			page.drawText("None", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("9|H Tree health", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("What % of trees within this plot are dead, or have crown dieback?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data.question9a !== "undefined" ? String(data.question9a) + "% are dead" : "No response for tree death", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data.question9a !== "undefined" ? String(data.dieback) + "% have crown dieback" : "No response for crown dieback", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Evidence of pests and disease", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		const text = data?.question9b ? (data.question9b == "1" ? "High-risk pests or diseases present" : (data.question9b == "2" ? "Low-risk pests or diseases present" : (data.question9b == "3" ? "No pests and diseases" : "No response"))) : "No response";
		page.drawText(text, {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("10|I Vegetation and ground flora", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Is the ground layer strongly characterised by ancient woodland specialists?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data?.question10a !== "undefined" ? (data.question10a ? "Yes" : "No") : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Is there a recognisable woodland NVC community at ground layer?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data?.question10b !== "undefined" ? (data.question10b ? "Yes" : "No") : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		multiTextHeight = await my_layoutMultilineText(
			pdfDoc, page,
			page.getHeight() - headerHeight - fontSize * lineSpace * line,
			typeof data?.nvcnotes !== "undefined" ? (String(data.nvcnotes)) : "None");
		line = line + multiTextHeight / (9 * lineSpace);

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("11|J Woodland vertical structure", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Tree size categories present", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		if (typeof data.question11 !== "undefined") {
			for (const item of data.question11) {
				const text = item == "upperlarge" ? "Upper storey of canopy (too wide to get arms around / at least 35 cm DBH)" : (item == "middle" ? "Middle storey of canopy (wider than a tin of beans / at least 7 cm DBH)" : (item == "lower" ? "Lower storey of canopy (saplings and/or coppice growth >130 cm tall >7 cm DBH)" : (item == "shrubs" ? "Shrub layer (Woody plants < 1.3m, tall such as hazel and holly)" : (item == "complex" ? "Complex (made up of multiple tree heights that cannot easily be split into height bands)" : ("None")))));
				page.drawText(text, {
					x: marginLeft,
					y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
					size: fontSize,
					font: pdfFont,
					color: fontColor
					// alignment: TextAlignment.Left
				});
				[line, page] = await incLineOrAddPage(line, pdfDoc, page);
			}
		}
		else {
			page.drawText("No response", {
				x: marginLeft,
				y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
				size: fontSize,
				font: pdfFont,
				color: fontColor
				// alignment: TextAlignment.Left
			});
			[line, page] = await incLineOrAddPage(line, pdfDoc, page);

		}

		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("13|L Amount of deadwood", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize + 2,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Is standing or fallen deadwood visible in the survey plot?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data?.question13a !== "undefined" ? (data.question13a ? "Yes" : "No") : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText("Are large dead branches/stems and stumps or an abundance of small tree cavities visible in the survey plot?", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFontBold,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		page.drawText(typeof data?.question13b !== "undefined" ? (data.question13b ? "Yes" : "No") : "No response", {
			x: marginLeft,
			y: page.getHeight() - headerHeight - fontSize * lineSpace * line,
			size: fontSize,
			font: pdfFont,
			color: fontColor
			// alignment: TextAlignment.Left
		});
		[line, page] = await incLineOrAddPage(line, pdfDoc, page);
		// return;

		const pdfBytes = await pdfDoc.save();

		// After generating the PDF
		saveAs(new Blob([pdfBytes], { type: "application/pdf" }), name + "-" + props.survey.assessment_date + ".pdf");

		return pdfBytes;
	}
	const LOGO_BASE64 = "data:image/png;base64,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";

	const now = new Date();
	const january = new Date(now.getFullYear(), 0, 1);
	const isBST = now.getTimezoneOffset() < january.getTimezoneOffset();

	function formatUpdatedAt() {
		if (!props.survey.synced_at) return "";
		const date = new Date(props.survey.synced_at);

		if (isBST) {
			date.setHours(date.getHours() + 1);
		}
		return date.toLocaleString();
	}
	function formatSyncedAt() {
		if (!props.survey.synced_at) return "";
		const date = new Date(props.survey.synced_at);

		if (isBST) {
			date.setHours(date.getHours() + 1);
		}
		return date.toLocaleString();
	}
	</script>

